import React from 'react';
import Hero from '../components/Hero';
import Gallery from './Gallery';
import Solutions from '../components/Solutions';
import Technology from '../components/Technology';
import Process from '../components/Process';
import data from '../data/siteData.json';

function Home() {
  return (
    <>
      <Hero data={data.hero} />
      <Gallery />
      <Technology data={data.technology} />
      <Process data={data.process} />
      <Solutions data={data.solutions} />
    </>
  );
}

export default Home;
